import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { Folder } from '../local-import.entity';
import { FileStatus } from '../local-import.enum';
import { ImportFileInfo } from '../local-import.interface';
import { getStatusClass, trackByForFolder, trackByForFile } from '../local-import.utils';

@Component({
  host: { 'test-id': 'local-import-table-folder-row' },
  selector: 'local-import-table-folder-row',
  styleUrls: ['./local-import-table-folder-row.component.scss'],
  templateUrl: './local-import-table-folder-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocalImportTableFolderRow {
  @Input() folder: Folder;
  @Input() status: FileStatus;

  @Output() readonly cancelFile = new EventEmitter<ImportFileInfo>();
  @Output() readonly retryFile = new EventEmitter<ImportFileInfo>();
  @Output() readonly cancelFolder = new EventEmitter<Folder>();
  @Output() readonly retryFolder = new EventEmitter<Folder>();

  protected readonly fileStatusEnum = FileStatus;
  protected readonly trackByForFolderFn = trackByForFolder;
  protected readonly trackByForFileFn = trackByForFile;

  readonly getStatusClassFn = getStatusClass;

  protected isOpen = false;
}
